import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux'
import clsx from 'clsx';
import moment from 'moment';
import withErrorHandler from '../../../hocs/withErrorHandler'
import axios from '../../../httpClients/axios-datamerch'
import SearchCountChart from '../SearchCountChart'

import * as actions from '../../../store/actions'

import {
  Grid,
  Divider,
  Typography,
  FormControlLabel,
  Switch
} from '@mui/material';

import useClasses from '../../../helpers/useClasses';
import { displayPartsToString } from 'typescript';


const styles = theme => ({
  root: {
    margin: '25px'
  },
  label: {
    padding: "10px",
    width: "200px",
    display: "inline-block"
  },
  value: {

  }
});

const MerchantSummaryPDF = props => {
  const { className, merchant, onSubmitClick, is_dm_admin, is_admin, account_merchant_subscription_enabled, onMerchantSubscriptionToggle, current_user, onFetchSearchCounts,search_counts,plan_level, ...rest } = props;
  const [fein, setFein] = useState('')
  const [legal_name, setLegalName] = useState('')
  const [dba, setDba] = useState('')
  const [city, setCity] = useState('')
  const [state, setState] = useState('')
  const [business_phone, setBusinessPhone] = useState('')
  const [business_startdate, setBusinessStartDate] = useState('')
  const [industry, setIndustry] = useState('')
  const [has_merchant_subscription, setHasMerchantSubscription] = useState(false)
  
  const classes = useClasses(styles);

  useEffect(() => {
    if(merchant && merchant.id){
      setFein(merchant.fein || '')
      setLegalName(merchant.legal_name || '')
      setDba(merchant.dba || '')
      setCity(merchant.city || '')
      setState(merchant.state || '')
      setBusinessPhone(merchant.business_phone || '')
      setBusinessStartDate(merchant.business_startdate || '')
      setIndustry(merchant.industry || '')
      setHasMerchantSubscription(merchant.has_merchant_subscription || false)
    }
  },[merchant])

  let subscriptionToggle = null

  const [show_search_history, setShowSearchHistory] = useState(false)
  const toggleSearchHistory = () => {
    setShowSearchHistory(!show_search_history)
  }

  useEffect(() => {
    if (plan_level === 'PRO'){
      onFetchSearchCounts(fein)
    }
  }, [fein])

  return (
    <div className={classes.root}>
      <div className={classes.attribute}>
        <span className={classes.label}>EIN:</span>
        <span className={classes.value}>{fein}</span>
      </div>
      <div className={classes.attribute}>
        <span className={classes.label}>Legal Name:</span>
        <span className={classes.value}>{legal_name}</span>
      </div>
      <div className={classes.attribute}>
        <span className={classes.label}>City, State:</span>
        <span className={classes.value}>{city}, {state}</span>
      </div>
      { dba !== '' ?
          <React.Fragment>
            <div className={classes.attribute}>
              <span className={classes.label}>DBA:</span>
              <span className={classes.value}>{dba}</span>
            </div>
          </React.Fragment>
      : null }
      { business_phone !== '' ?
          <React.Fragment>
            <div className={classes.attribute}>
              <span className={classes.label}>Business Phone:</span>
              <span className={classes.value}>{business_phone}</span>
            </div>
          </React.Fragment>
      : null }
      { business_startdate !== '' ?
          <React.Fragment>
            <div className={classes.attribute}>
              <span className={classes.label}>Business Start Date:</span>
              <span className={classes.value}>{business_startdate}</span>
            </div>
          </React.Fragment>
      : null }
      { industry !== '' ?
          <React.Fragment>
            <div className={classes.attribute}>
              <span className={classes.label}>Industry:</span>
              <span className={classes.value}>{industry}</span>
            </div>
          </React.Fragment>
      : null }
      <div className={classes.attribute}>
        <span className={classes.label}>Added By:</span>
        <span className={classes.value}>{merchant.added_by}</span>
      </div>
      <div className={classes.attribute}>
        <span className={classes.label}>Added On:</span>
        <span className={classes.value}>{moment(merchant.created_at).format('MM/DD/YYYY')}</span>
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    current_user: state.auth.user,
    is_dm_admin: state.auth.user.is_dm_admin,
    is_admin: state.auth.user.is_admin,
    account_merchant_subscription_enabled: state.auth.user.account_merchant_subscription_enabled,
    search_counts: state.searchCount.search_counts,
    plan_level: state.auth.user.plan_level 
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onFetchSearchCounts: (search) => dispatch(actions.fetchSearchCounts(search))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(MerchantSummaryPDF, axios))